import { Skeleton } from '@/_components/ui/skeleton'
import { TabNav } from '@/features/_components/ui/tab-nav'
import { useIsRouteActive } from '@/features/_hooks/use-is-route-active'
import { Link, useParams } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'

export function FacilityHeaderLoading() {
  const { companySlug } = useParams({ strict: false }) as { companySlug: string }
  const isPersonRouteActive = useIsRouteActive('facilities', 'applications')
  const isSettingsRouteActive = useIsRouteActive('facilities', 'settings')

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Link
          to={`/companies/${companySlug}/facilities` as any}
          className="flex w-fit items-center gap-0.5 text-xs text-muted-foreground transition-colors hover:text-foreground"
        >
          <ChevronLeft size={14} />
          Voltar
        </Link>
        <Skeleton className="h-8 w-48" />
      </div>
      <TabNav
        items={[
          { label: 'Pacientes', href: '#', isActive: isPersonRouteActive },
          { label: 'Configurações', href: '#', isActive: isSettingsRouteActive },
        ]}
      />
    </div>
  )
}
